import cn from 'classnames';

import MealCookTime from 'components/common/MealCookTime';
import MealPrimaryLabel from 'components/common/MealPrimaryLabel';
import MealTags from 'components/common/MealTags';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';
import { TEMPO } from 'lib/constants';
import style from 'styles/components/menuSearch/MealCard';
import commonCardStyle from 'styles/shared/dashboardMealCard';
import * as Types from 'utilities/types';

import OrderableMenuLabel from './OrderableMenuLabel';

const MealCard = ({
  meal: {
    title,
    subtitle,
    photo,
    url,
    primaryLabelData,
    currentOrderableMenuDateFormatted,
    currentOrderableMenuDate,
    mealPlanSlug,
    prepMinutes,
  },
  meal,
}) => {
  const handleClickWithAnalytics = useAnalyticsCallback(
    null,
    ({ logEvent, events, callbackArgs }) => {
      logEvent(events.menuSearch.recipeSearchMealCardClicked, { menuDate: callbackArgs[0] });
    },
    []
  );
  const isTempo = mealPlanSlug === TEMPO;

  return (
    <article className={cn(commonCardStyle.mealCard, style.mealCard, 'bg-white-100 shadow')}>
      <a
        href={url}
        className={cn(commonCardStyle.cardChild)}
        onClick={() => handleClickWithAnalytics(currentOrderableMenuDate)}
      >
        <div className="relative">
          <img width="100%" alt={title} src={photo} className={style.menuSearchCardImg} />
          {currentOrderableMenuDateFormatted && (
            <OrderableMenuLabel
              date={currentOrderableMenuDateFormatted}
              mealPlanSlug={mealPlanSlug}
            />
          )}
        </div>
        <div className={cn(commonCardStyle.body, 'm-2 text-charcoal-100 bp1:m-4')}>
          <div className="mb-2">
            {Boolean(primaryLabelData) && (
              <MealPrimaryLabel
                containerStyle="h7 mr-2 py-1 text-xxs bp1:text-sm inline-block mb-2"
                primaryLabel={primaryLabelData.labelText}
                hexColor={primaryLabelData.textColorHexCode}
              />
            )}
            <h4 className={cn(style.title, 'h6')}>{title}</h4>
            <p className={cn(style.subtitle, 'text mb-2 text-charcoal-90')}>{subtitle}</p>
            {isTempo && (
              <MealCookTime
                prepMinutes={prepMinutes}
                textClass="textSm my-4 lowercase text-charcoal-90"
                showClock={false}
              />
            )}
            <MealTags textClass="textSm" meal={meal} />
          </div>
        </div>
      </a>
    </article>
  );
};

MealCard.propTypes = {
  meal: Types.meal.isRequired,
};

export default MealCard;
